// sidebar-content.js
import React from "react";
import {
  NpaPropertiesIcon,
  NpaInquiriesIcon,
  RecordIcon,
  ArrowRight02Icon2,
  Building03Icon,
  UserIcon,
} from "../../assets/icons";
import { routes } from "../../routes/pageRoutes";

export const SidebarContent = [
  {
    title: "NPA",
    to: "#",
    icon: <NpaPropertiesIcon width={18} height={18} color="#444050" strokeWidth="2" />,
    dropdownIcon: <ArrowRight02Icon2 width={18} height={18} color="#444050" strokeWidth="2" />,

    // 2nd level items inside NPA
    children: [
      {
        title: "NPA Properties",
        icon: <NpaPropertiesIcon width={18} height={18} color="#444050" strokeWidth="2" />,
        link: routes.npaProperties,
      },
      {
        title: "NPA Inquiries",
        icon: <NpaInquiriesIcon width={22} height={22} color="#444050" strokeWidth="2" />,
        link: routes.npaInquiries,
      },

      // 2nd level group → has its own children (3rd level)
      {
        title: "User Details",
        to: "#",
        icon: <UserIcon width={18} height={18} color="#444050" strokeWidth="2" />,
        dropdownIcon: <ArrowRight02Icon2 width={18} height={18} color="#444050" strokeWidth="2" />,
        children: [
          {
            title: "All Users",
            icon: <RecordIcon width={10} height={10} color="#444050" strokeWidth="3" />,
            link: routes.allUsers,
          },
          {
            title: "Requested User",
            icon: <RecordIcon width={10} height={10} color="#444050" strokeWidth="3" />,
            link: routes.requestedUser,
          },
          {
            title: "Approved User",
            icon: <RecordIcon width={10} height={10} color="#444050" strokeWidth="3" />,
            link: routes.approvedUser,
          },
          {
            title: "Rejected Users",
            icon: <RecordIcon width={10} height={10} color="#444050" strokeWidth="3" />,
            link: routes.rejectedUser,
          },
        ],
      },

      // 2nd level group → has its own child list (3rd level)
      {
        title: "Bank Manage",
        to: "#",
        icon: <Building03Icon width={18} height={18} color="#444050" strokeWidth="2" />,
        dropdownIcon: <ArrowRight02Icon2 width={18} height={18} color="#444050" strokeWidth="2" />,
        children: [
          {
            title: "Banks",
            icon: <RecordIcon width={10} height={10} color="#444050" strokeWidth="3" />,
            link: routes.banks,
          },
          // If needed later:
          // {
          //   title: "Banks Detail",
          //   icon: <RecordIcon width={10} height={10} color="#444050" strokeWidth="3" />,
          //   link: routes.viewBanksDetail,
          // },
        ],
      },
    ],
  },
  {
    // Top-level group
    title: "All Properties",
    to: "#",
    icon: <NpaPropertiesIcon width={18} height={18} color="#444050" strokeWidth="2" />,
    dropdownIcon: <ArrowRight02Icon2 width={18} height={18} color="#444050" strokeWidth="2" />,
    link: routes.npaPublicProperties,
  },
];
